import { CommentInterface } from 'modules/comments/components/comment/comment.types'

export const parseParentIdFromKey = (key: string): { parentId: number; isReply: boolean } => {
  const queryString = key.split('?')[1] || ''
  const params = new URLSearchParams(queryString)
  const parentParam = params.get('parent')
  return {
    parentId: parseInt(parentParam || '0', 10),
    isReply: parentParam !== 'null',
  }
}

export const findCommentById = (
  comments: CommentInterface[],
  id: number,
): CommentInterface | null => {
  for (const comment of comments) {
    if (comment.id === id) {
      return comment
    }

    if (comment.children?.length) {
      const childTarget = comment.children.find(child => child.id === id)
      if (childTarget) {
        return childTarget
      }
    }
  }

  return null
}

export const handleTargetComment = (
  data: CommentInterface[],
  initialTargetCommentId: number | undefined,
  setHighlightedComment: (comment: CommentInterface) => void,
  highlightedComment: CommentInterface | null,
  setInitialTargetCommentId?: (id: number | undefined) => void,
) => {
  if (initialTargetCommentId && data.length > 0 && !highlightedComment) {
    const target = findCommentById(data, initialTargetCommentId)
    if (target) {
      setHighlightedComment(target)
      return
    }
    // Try to find target-comment only once, prevent infinite search in case of wrong value
    setInitialTargetCommentId?.(undefined)
  }
}
